import { waLink, track } from "@/constants/site";
import Reveal from "@/components/base/Reveal";

const HIGHLIGHTS = [
  { icon: "ri-user-star-line", label: "Atendimento próximo" },
  { icon: "ri-award-line", label: "Competência técnica" },
  { icon: "ri-building-2-line", label: "Estrutura industrial" },
  { icon: "ri-team-line", label: "Relacionamento B2B" },
];

export default function About() {
  return (
    <section id="empresa" className="bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2 lg:gap-14">
          <Reveal>
            <div className="relative overflow-hidden rounded-lg border border-background-200">
              <img
                src="https://storage.helloreaddy.io/project_files/f9d550f4-c229-4b78-8b12-ba157551dbe2/f208b552-5791-4996-9924-1b3d711b32f2_compressed_powermotoreseletricos-20.webp"
                alt="Estoque de motores elétricos WEG na Power Motores Elétricos"
                title="Estoque de motores - Power Motores Elétricos"
                className="h-full w-full object-cover object-center"
              />
            </div>
          </Reveal>

          <Reveal delay={120}>
            <p className="text-xs font-bold uppercase tracking-[0.16em] text-accent-600">
              Power Motores Elétricos
            </p>
            <h2 className="mt-3 font-heading text-3xl font-extrabold leading-tight tracking-tight text-foreground-950 md:text-4xl">
              Conhecimento técnico para cuidar de equipamentos essenciais à sua operação.
            </h2>
            <p className="mt-4 text-base leading-relaxed text-foreground-600">
              A Power Motores Elétricos atua na manutenção, recuperação e fornecimento de
              motores elétricos e equipamentos industriais. Nosso compromisso é entender a
              necessidade de cada cliente e apresentar a solução técnica adequada, com
              atendimento ágil e próximo de quem mantém a produção em movimento.
            </p>

            <div className="mt-7 grid grid-cols-2 gap-3">
              {HIGHLIGHTS.map((h) => (
                <div
                  key={h.label}
                  className="flex items-center gap-2 rounded-md border border-background-200 bg-background-100 px-4 py-3"
                >
                  <i className={`${h.icon} text-lg text-primary-600`} aria-hidden="true" />
                  <span className="text-sm font-semibold text-foreground-800">{h.label}</span>
                </div>
              ))}
            </div>

            <a
              href={waLink("Olá! Gostaria de conhecer melhor a Power Motores Elétricos.")}
              target="_blank"
              rel="noreferrer"
              onClick={() => track("whatsapp_click")}
              className="mt-8 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-primary-300 px-6 py-3.5 text-base font-bold text-primary-700 transition-colors hover:bg-primary-50"
            >
              Falar com a equipe
              <i className="ri-whatsapp-line text-xl" aria-hidden="true" />
            </a>
          </Reveal>
        </div>
      </div>
    </section>
  );
}